import { colours } from '@headbox-ui/themes'

const { white, grey } = colours

export const layout = {
  backgroundColor: white,
  borderBottom: `${grey[99] as string} 1px solid`,
  padding: '0 40px',
  position: 'fixed' as 'fixed',
  top: 0,
  width: '100vw',
  zIndex: 101
}

export const head = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end'
}

export const wrapper = {
  margin: '0 auto',
  maxWidth: 1278,
  padding: '0',
  width: '100%'
}

export const anchor = {
  display: 'inline-flex',
  marginRight: 'auto',
  paddingRight: 20
}

export const logo = {
  maxWidth: 200,
  minWidth: 140
}
